import * as types from '../constants/actionTypes';

export function selectedUnderwriter(item) {
    return {
        type: types.SELECTED_UNDERWRITER,
        payload: item
    };
}
export function unselectedUnderwriter() {
    return {
        type: types.UNSELECTED_UNDERWRITER,
    };
}
export function selectedCompany(item) {
    return {
        type: types.SELECTED_COMPANY,
        payload: item
    };
}
export function unselectedCompany() {
    return {
        type: types.UNSELECTED_COMPANY,
    };
}
export function selectedClient(item) {
    return {
        type: types.SELECTED_CLIENT,
        payload: item
    };
}
export function unselectedClient() {
    return {
        type: types.UNSELECTED_CLIENT,
    };
}
export function selectedVessel(item) {
    return {
        type: types.SELECTED_VESSEL,
        payload: item
    };
}
export function unselectedVessel() {
    return {
        type: types.UNSELECTED_VESSEL,
    };
}


// WEBPACK FOOTER //
// ./src/actions/selected.js